import React from "react";

const ContactMap = () => {
  return (
    <section className="contactMap">
      <div className="container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d300.82689677760936!2d71.68923262342565!3d40.90545607133316!2m3!1f1.171885594160121!2f55.109596963297854!3f0!3m2!1i1024!2i768!4f35!5e1!3m2!1sen!2s!4v1702397003327!5m2!1sen!2s"
          width="100%"
          height="550px"
          style={{ border: "0" }}
          allowFullScreen=""
          loading="lazy"
          title="Google Maps"
        ></iframe>
      </div>
    </section>
  );
};

export default ContactMap;
